import React from "react";
import Header from "@/components/sad/Header";
import Hero from "@/components/sad/Hero";
import Services from "@/components/sad/Services";
import Statement from "@/components/sad/Statement";
import Furniture from "@/components/sad/Furniture";
import Process from "@/components/sad/Process";
import WhyMe from "@/components/sad/WhyMe";
import Portfolio from "@/components/sad/Portfolio";
import Zone from "@/components/sad/Zone";
import QuoteForm from "@/components/sad/QuoteForm";
import Footer from "@/components/sad/Footer";
import WhatsAppButton from "@/components/sad/WhatsAppButton";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-stone-50 text-stone-900">
      <Header />
      <Hero />
      <Services />
      <Statement />
      <Furniture />
      <Process />
      <WhyMe />
      <Portfolio />
      <Zone />
      <QuoteForm />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
